import React from 'react';
import styled from 'styled-components';

const MainContainer = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  items-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;
const Data = styled.div`
  font-family: 'PP Neue Montreal', sans-serif;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  items-align: center;
  border: 1.2px solid #c6ccff;
  margin: auto;
  padding: 5rem 0rem;
  font-weight: 500;
`;
export const NoData = () => {
  return (
    <MainContainer>
      <Data>No available data</Data>
    </MainContainer>
  );
};
